export default __webpack_public_path__ + "static/media/hostaway_step2.6a18a33b.jpg";